import { transport } from "@/src/config/apiConfig.js";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

export default {
  getBasePath() {
    return BASE_PATH;
  },

  isDefined(val) {
    return typeof val !== "undefined" && val !== null;
  },

  /* --------------- Billing APIs --------------- */

  async getBillingCredits(params) {
    let res = await transport.get(`/api/billing_credits/info`, {
      params: params,
    });
    return res.data;
  },

  async getBillingRecords(params) {
    let res = await transport.get(`/api/billing_records`, {
      params: params,
    });
    return res.data;
  },

  async getPricingTiers() {
    let res = await transport.get(`/api/billing/pricing_tiers`);
    return res.data;
  },

  async getBillingAccount() {
    let res = await transport.get(`/api/billing/account`);
    return res.data;
  },

  async updatePopUpShown() {
    let res = await transport.get(`/api/billing/popupshown`);
    return res.data;
  },

  async startCheckoutSession(payload) {
    let res = await transport.post(`/api/billing/checkout_session`, payload);
    return res.data;
  },

  async changePricing(payload) {
    let res = await transport.post(`/api/billing/change_pricing`, payload);
    return res.data;
  },

  async cancelSubscription(payload) {
    let res = await transport.post(`/api/billing/cancel_subscription`, payload);
    return res.data;
  },

  async manageBilling(payload) {
    let res = await transport.post(`/api/billing/manage`, payload);
    return res.data;
  },

  async getTotalSeats() {
    let res = await transport.get(`/api/billing/total_seats`);
    return res.data;
  },

  async getTotalUsage() {
    let res = await transport.get(`/api/billing/total_usage`, {
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return res.data;
  },

  async checkPaymentDue() {
    let res = await transport.get(`/api/billing/check_payment_due`);
    return res.data;
  },

  /* --------------- Setup Billing APIs --------------- */

  async getAllPlans() {
    try {
      const res = await transport.get(`/api/billing/plans`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting all plans: ", error);
    }
  },

  async calculateDue(params) {
    try {
      const res = await transport.get(`/api/billing/calculate_due`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while calculating due: ", error);
    }
  },

  async setupBilling(payload) {
    try {
      const res = await transport.post(`/api/billing/setup_billing`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating checkout session: ",
        error,
      );
    }
  },

  async newAccountToFreePlan(payload) {
    try {
      const fbp = getCookie("_fbp");
      const fbc = getCookie("_fbc");

      const res = await transport.post(
        `/api/billing/new_account_to_free_plan`,
        payload,
        {
          headers: {
            "X-FBP": fbp,
            "X-FBC": fbc,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while setting up free plan: ", error);
    }
  },

  async getV2Pricing() {
    try {
      const res = await transport.get(`/api/billing/v2/pricing`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching v2 pricing: ", error);
    }
  },

  async createRazorpaySeatSubscription(payload) {
    try {
      const res = await transport.post(
        `/api/billing/razorpay_seat_subscription`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating razorpay seat subscription: ",
        error,
      );
    }
  },

  async createStripeV2Subscription(payload) {
    try {
      const res = await transport.post(
        `/api/billing/stripe_v2_subscription`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating stripe v2 subscription: ",
        error,
      );
    }
  },

  async checkoutSessionTrial(payload) {
    try {
      const fbp = getCookie("_fbp");
      const fbc = getCookie("_fbc");

      const res = await transport.post(
        `/api/billing/checkout_session_trial`,
        payload,
        {
          headers: {
            "X-FBP": fbp,
            "X-FBC": fbc,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating trial checkout session: ",
        error,
      );
    }
  },

  async getEnabledBillingPeriods() {
    try {
      const res = await transport.get(`/api/billing/enabled_billing_periods`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting enabled billing periods: ",
        error,
      );
      return null;
    }
  },

  async getEnabledTiers() {
    try {
      const res = await transport.get(`/api/billing/enabled_tiers`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting enabled tiers: ", error);
      return null;
    }
  },
};
